<motif-card
  orientation="horizontal"
  [ngClass]="{ unread: notification && notification.isRead === false }"
  class="notification-card"
  cardVariant="full-width"
>
  <motif-card-body>
    <div class="motif-row">
      <div class="motif-col-xs-10">
        <div class="notif-content">
          <div class="notification-avatar">
            <button
              motifIconButton
              class="bellbutton"
              aria-label="Notification Type"
            >
              <motif-icon size="20" [iconFunction]="solidBellIcon"></motif-icon>
            </button>
          </div>

          <div
            *ngIf="notification.type == 'Approval'"
            (click)="openApprovalLink(notification)"
            [ngClass]="{
              unread: notification && notification.isRead === false,
            }"
            (keydown.enter)="
              $event.preventDefault(); $any($event.target).click()
            "
            (keydown.space)="
              $event.preventDefault(); $any($event.target).click()
            "
            class="notification-message clickable"
          >
            <span [innerHTML]="messageHtml"></span>
          </div>
          <div
            *ngIf="notification.type == 'General'"
            [ngClass]="{
              unread: notification && notification.isRead === false,
            }"
            class="notification-message"
          >
            <span [innerHTML]="messageHtml"></span>
          </div>
          <div
            *ngIf="notification.type == 'Comment'"
            [ngClass]="{
              unread: notification && notification.isRead === false,
            }"
            class="notification-message clickable"
            (click)="openCommentLink(notification)"
            (keydown.enter)="
              $event.preventDefault(); $any($event.target).click()
            "
            (keydown.space)="
              $event.preventDefault(); $any($event.target).click()
            "
          >
            <span [innerHTML]="messageHtml"></span>
            <blockquote class="comment-quote">
              <span [innerHTML]="commentHtml"></span>
            </blockquote>
          </div>
          <div
            [ngClass]="{
              unread: notification && notification.isRead === false,
            }"
            class="iconClass"
          >
            <button
              motifIconButton
              aria-label="Close modal"
              [motif-tooltip]="'DeleteNotification' | translate"
              [size]="buttonSizes.SMALL"
              (click)="deleteNotification(notification)"
            >
              <motif-icon size="20" [iconFunction]="closeIcon"></motif-icon>
            </button>
            <button
              motifIconButton
              aria-label="Close modal"
              *ngIf="notification && notification.isRead === false"
              [motif-tooltip]="'MarkAsRead' | translate"
              [size]="buttonSizes.SMALL"
              (click)="markAsRead(notification)"
            >
              <motif-icon size="20" [iconFunction]="readIcon"></motif-icon>
            </button>
          </div>
        </div>
      </div>
      <div class="notification-date">
        {{ commonService.formatUtcToRelative(notification.createdAt) }}
      </div>
    </div>
  </motif-card-body>
</motif-card>
